var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LandingHeader',[_c('div',{staticClass:"service-page"},[_c('ServicePageHeader',{attrs:{"icon":_vm.icon,"title":_vm.title,"subtitle":_vm.subtitle,"show-back-link":_vm.showBackLink}}),_c('main',{staticClass:"service-content"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }